
export default function useUtilities () {
  const UUID = () => {
    const s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  const getEnvironment = () => {
    return '';
  }

  const formatPrice = (nr) => {
    if (typeof nr !== 'number') {
      return nr
    }
    const withoutDigits = Math.ceil(nr)
    const price = new Intl.NumberFormat('da-DK', {}).format(withoutDigits)
    return price
  }

  const getDateAfterDays = (numberOfDays) => {
    const today = new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)
    const lastDay = new Date();
    lastDay.setDate(today.getDate() + numberOfDays);
    return lastDay
  }

  const getDateInFormat = (dateToBeFormatted) => {
    if (dateToBeFormatted) {
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      const formattedDate = new Date(dateToBeFormatted).toLocaleDateString('da-DK', options)
      return formattedDate.toString().charAt(0).toLocaleUpperCase() + formattedDate.toString().slice(1)
    }
    return ''
  }

  const smsAndMmsCap = (subscription) => {
    const smsCap = subscription?.caps?.find(cap => cap.capType === 'SMS_CAP')
    const mmsCap = subscription?.caps?.find(cap => cap.capType === 'MMS_CAP')
    if (smsCap?.capValue === 99999999 && mmsCap?.capValue === 99999999) {
      return 'Fri sms og mms'
    }
    return smsCap?.capValue + ' sms og ' + mmsCap?.capValue + ' mms'
  }
  const voiceCap = (subscription) => {
    const voice = subscription?.caps?.find(cap => cap.capType === 'VOICE')
    if (voice?.capValue !== 0) {
      const voiceInHours = voice?.capValue / 60
      return voice?.unlimited ? 'Fri tale' : voiceInHours + ' timers tale'
    }
    return ''
  }

  const calculateDataCap = (subscription) => {
    let data = subscription?.caps?.find(cap => cap.capType === 'DATA')
    const convertUnits = {
      MEGABYTES: 1024
    }
    data = (data?.capValue) / convertUnits[data?.unit]
    return data
  }
  const dataCap = (subscription, separator, isInternet = false) => {
    const data = calculateDataCap(subscription)
    if (isInternet) {
      return data >= 4800 ? separator + ' Fri Data' : separator + ' ' + data + ' GB data '
    }
    return data >= 1000 && !isInternet ? separator + ' Fri Data' : separator + ' ' + data + ' GB data '
  }

  const roamingDataCap = (subscription, separator) => {
    const roamingData = subscription?.caps?.find(cap => cap.capType === 'ROAMING_DATA_CAP')
    return roamingData?.capValue !== 0 ? separator + ' ' + roamingData?.capValue + ' GB i EU' : ''
  }

  const isFiveG = (subscription) => {
    return subscription?.displayName?.includes('5G') ? '5G' : '4G'
  }

  const getSubscriptionName = (subscription, _separator, _preText = '', _isInternet = false, _isPayG = false) => {
    return subscription?.displayName
  }
  const getInternetPlayMixDisplayName = (subscription, _separator) => {
    return subscription?.displayName
  }
  return {
    isFiveG,
    calculateDataCap,
    smsAndMmsCap,
    roamingDataCap,
    voiceCap,
    dataCap,
    getSubscriptionName,
    getDateInFormat,
    getDateAfterDays,
    formatPrice,
    UUID,
    getEnvironment,
    getInternetPlayMixDisplayName
  }
}
